import { dataBackgroundSwitchSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBackgroundSwitchSolid = /*#__PURE__*/createIcon(dataBackgroundSwitchSolid)
export default IconBackgroundSwitchSolid
